import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import FooterOne from '../../../../assets/images/footer_1.png';
import FooterTwo from '../../../../assets/images/footer_2.png';
import FooterThree from '../../../../assets/images/footer_3.png';

import './style/footer.css';

export default function Footer() {
  return (
    <footer className="footer-container container-fluid">
      <Container>
        <Row>
          <Col lg={4} className="footer-left">
            <img alt="CEINGE" src={FooterOne} className="img-responsive" loading="lazy" />
            <img alt="Kelyon" src={FooterTwo} className="img-responsive" loading="lazy" />
            <img
              alt="Regione Calabria"
              src={FooterThree}
              className="img-responsive"
              loading="lazy"
            />
          </Col>
          <Col lg={4} className="footer-center">
            {/* <Link to={privacyRoute}>Informativa sulla Privacy</Link> /*}
            {/* TODO: Mostrare solo in metabolico? */}
            {/* <Link to={consentRoute}>Informativa sullo Screening Neonatale</Link>  */}
          </Col>
          <Col md={4} className="footer-right" />
        </Row>
      </Container>
    </footer>
  );
}
